/**
 * The trust tokens this browser keeps, one per account that trusted it, keyed by user id.
 * Sign-in sends them all; the API honours only the one belonging to the account signing in.
 */
const STORAGE_KEY = "trusted_browsers";

// The login endpoint accepts at most this many (`trusted_browser_tokens`, max:10).
const MAX_ACCOUNTS = 10;

const readEntries = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
};

const writeEntries = (entries) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    // Storage is blocked (a private window): the browser is simply not remembered.
  }
};

export const trustedBrowserTokens = () =>
  Object.values(readEntries())
    .map((entry) => entry?.token)
    .filter(Boolean);

export const trustedBrowserIdFor = (userId) =>
  readEntries()[userId]?.id ?? null;

export const rememberTrustedBrowser = (userId, { id, token }) => {
  const entries = {
    ...readEntries(),
    [userId]: { id, token, savedAt: Date.now() },
  };
  const newestFirst = Object.entries(entries)
    .sort(([, a], [, b]) => (b?.savedAt ?? 0) - (a?.savedAt ?? 0))
    .slice(0, MAX_ACCOUNTS);

  writeEntries(Object.fromEntries(newestFirst));
};

export const forgetTrustedBrowser = (userId) => {
  const entries = readEntries();
  delete entries[userId];
  writeEntries(entries);
};
